<template>
  <ui-card class="spacer-margin">
    <ui-heading no-top-margin>{{ this.heading }}</ui-heading>
    <screening-details-child
      v-for="(key, index) in Object.keys(tree)"
      :key="`${index}-${key}`"
      :itemKey="key"
      :itemValue="tree[key]"
    />
  </ui-card>
</template>

<script>
import ScreeningDetailsChild from "../components/ScreeningDetailsChild.vue";

export default {
  components: { ScreeningDetailsChild },
  props: {
    heading: String,
    tree: Object
  }
};
</script>
